import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor() { }

  getPreferredLanguage(): Promise<string> {
    const lang = navigator.language;
    return new Promise(resolve => {
      resolve(lang);
    });
  }
}
